import TariffCard from './TariffCard.vue';

export { TariffCard };



// WEBPACK FOOTER //
// ./src/modules/home/tariffCard/index.js